import { create } from "zustand"
import { addBranch, addUserBranch, removeBranch, removeUserBranch, retrieveBranches, retrieveUserBranches, updateBranch } from "./actions"
import { Dictionary } from "../users/store"

export type BranchData = {
    id: string,
    name: string,
}

export type UserBranch = {
    id: string,
    branch: string
    servicing?: boolean
}

type BranchProps = {
    branches: Dictionary<BranchData[]>
    userBranches: Dictionary<UserBranch[]>
    retrieveBranches: (com:string) => Promise<string>
    updateBranch: (branch:BranchData, com:string) => Promise<string>
    addBranch: (com:string,branch:BranchData) => Promise<string>
    removeBranch: (id:string, com:string) => Promise<string>
    addUserBranch: (userid:string,com:string, branch:string, servicing:boolean) => Promise<string>
    removeUserBranch: (com:string, userid:string, branch:string) => Promise<string>
    retrieveUserBranches: (com:string,userid:string,offset:number) => Promise<any>
    getBranch: (com:string,branch:string) => BranchData
}

export const useBranch = create<BranchProps>( (set, getState) => ({
    branches: {},
    userBranches: {},
    async retrieveBranches(com:string) {
        const res = await retrieveBranches(com)
        if (res.Code === "200") {
            const branchDic = {...getState().branches}
            branchDic[com] = res.Msg.branches
            set( state => ({branches:branchDic}))
        }
        return res.Code
    },
    async addBranch(com,branch) {
        const code = await addBranch(branch.id, branch.name, com)
        if (code === "200") {
            const branches = {...getState().branches}
            branch.id = com + "." + branch.id
            if (!branches[com]) branches[com] = []
            branches[com]!.push(branch)
            set(state => ({branches:branches}))
        }
        return code
    },
    async updateBranch(branch,com) {
        const code = await updateBranch(branch.id,com, branch.name)
        if (code === "200") {
            const branches = {...getState().branches}
            const cbranches = branches[com]
            const index = cbranches?.findIndex( item => item.id === branch.id)
            if (index !== -1) {
                cbranches![index!].name = branch.name  
                branches[com] = cbranches
                set(state => ({branches: branches}))
            }
        }
        return code
    },
    async removeBranch(id,com) {
        const code = await removeBranch(id, com)
        if (code === "200") {
            const branches = {...getState().branches}
            const cbranches = branches[com]
            const index = cbranches?.findIndex( item => item.id === id)
            if (index !== -1) {
                cbranches?.splice(index!,1)
                branches[com] = cbranches
                set(state => ({branches: branches}))
            }
        }
        return code
    },
    async addUserBranch(userid, com, branch, servicing) {
        const res = await addUserBranch(userid, com, branch, servicing)
        if (res.Code === "200") {
            const branches = {...getState().userBranches}
            if (!branches[userid]) branches[userid] = []
            // set the old servicing to false
            if (servicing) {
                const index = branches[userid]!.findIndex(item => item.servicing)
                if (index !== -1) {
                    branches[userid]![index].servicing = false
                }
            }
            branches[userid]!.push({
                id:branch,
                branch:getState().getBranch(com, branch).name,
                servicing: servicing,
            })
            set(state =>({userBranches: branches}))
        }
        return res.Code
    },
    async removeUserBranch(com, uname, id) {
        const code  = await removeUserBranch(com, uname, id)
        if (code === "200") {
            const branches = {...getState().userBranches}
            const cbranches = branches[uname]
            const index = cbranches?.findIndex( item => item.id === id)
            if (index !== -1) {
                cbranches?.splice(index!,1)
                branches[uname] = cbranches
                set(state => ({userBranches: branches}))
            }
        }
        return code
    },
    async retrieveUserBranches(com, uname, offset) {
        const res = await retrieveUserBranches(com, uname, offset)
        if (res.Code === "200") {
            const branches : string[] = res.Msg.branches
            const sbranches = {...getState().userBranches}
            const servicing = res.Msg.servicing
            sbranches[uname] = branches.map<UserBranch>( br => ({
                id: br, 
                branch: getState().getBranch(com, br).name,
                servicing: br===servicing,
            }))
            set(state => ({userBranches: sbranches!}))
        } 
        return res 
    },
    getBranch(com, branch) {
        return getState().branches[com]?.find( item => item.id === branch)!
    },
}))